import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "w-50px fs-3 fw-bold text-black-50 ms-3" }, ": 1", -1)
const _hoisted_6 = { style: {"color":"#900000"} }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 me-2" }, "=>", -1)

import { computed, inject, onMounted, reactive, ref, watch } from "vue";
import {
  ConfigBackendCurrencySelections,
  isUSC,
} from "@/core/types/CurrencyTypes";
import UserService from "../services/UserService";
import RebateService from "@/projects/tenant/modules/rebate/services/RebateService";

import {
  ConfigAllServiceSelections,
  ConfigAllPlatformSelections,
} from "@/core/types/ServiceTypes";
import type { FormInstance, FormRules } from "element-plus";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { ConfigLeverageSelections } from "@/core/types/LeverageTypes";
import GlobalService from "@/projects/tenant/services/TenantGlobalService";
import i18n from "@/core/plugins/i18n";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";
import { ApplicationStatusType } from "@/core/types/ApplicationInfos";
import { ElNotification } from "element-plus";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";

export default /*#__PURE__*/_defineComponent({
  __name: 'AccountCreate',
  props: {
    accountDetails: {}
  },
  emits: ["accountSubmitted", "closeTest"],
  setup(__props: any, { expose: __expose, emit: emits }) {

const props = __props;

const { t } = i18n.global;
const isLoading = ref(false);
const isSaving = ref(false);



const accountDetails = inject(
  AccountInjectionKeys.ACCOUNT_DETAILS,
  ref<any>({})
);

const applicationDetails = inject(
  AccountInjectionKeys.APPLICATION_DETAILS,
  ref<any>({})
);

const pendingApplication = inject<any>(
  AccountInjectionKeys.APPLICATION_DETAILS
);

const services = inject(AccountInjectionKeys.PLATFORM_SERVICES, ref<any>({}));

const elFormRef = ref<FormInstance>();

const rules = reactive<FormRules>({
  platform: [
    { required: true, message: "Please select Platform", trigger: "blur" },
  ],
  serviceId: [
    { required: true, message: "Please select Server", trigger: "blur" },
  ],
  group: [{ required: true, message: "Please select Group", trigger: "blur" }],
  currencyId: [
    { required: true, message: "Please select Currency", trigger: "blur" },
  ],
  leverage: [
    { required: true, message: "Please select Leverage", trigger: "blur" },
  ],
  pcTag: [{ required: true, message: "Please select Tag", trigger: "blur" }],
});

const serverSelections = ref(Array<any>());
const groupSelections = ref(Array<any>());
const formData = ref({} as any);
const originalFormData = ref({} as any);
const pipCommissionDecision = ref({} as any);
const initialFlag = ref(true);

watch(
  () => formData.value.platform,
  () => {
    serverSelections.value = services.value.reduce((acc: any, service: any) => {
      if (service.platform !== formData.value.platform) return acc;
      acc.push({
        label: service.name + " (" + service.description + ")",
        value: service.id,
      });
      return acc;
    }, []);

    if (!initialFlag.value) formData.value.serviceId = null;
    initialFlag.value = false;
  }
);

watch(
  () => formData.value.serviceId,
  () => {
    formData.value.group = null;
    updateGroupSelections();
  }
);

watch(
  () => formData.value.currencyId,
  () => {
    formData.value.group = null;
    updateGroupSelections();
  }
);

const updateGroupSelections = () => {
  const allGroups =
    services.value.find(
      (service: any) => service.id === formData.value.serviceId
    )?.groups || [];

  if (isUSC(formData.value.currencyId)) {
    // 如果选择的是 USC，只显示包含 "USC" 的群组
    groupSelections.value = allGroups.filter((group: string) =>
      group.includes("USC")
    );
  } else {
    groupSelections.value = allGroups;
  }
};



const submit = async () => {
  if (!elFormRef.value) return;
  await elFormRef.value.validate(async (valid, fields) => {
    if (valid) {
      isSaving.value = true;
      try {
        const createdAccount = await UserService.createTradeAccount(
          formData.value
        ).then(async (res) => {
          await updateTag(res.id);
          return res;
        });

        console.log("createdAccount", createdAccount);

        await UserService.completeApplication(applicationDetails.value.id, {});
        isSaving.value = false;
        ElNotification({
          title: t("tip.accountCreateSuccess"),
          type: "success",
        });

        emits("accountSubmitted", createdAccount);

        // MsgPrompt.success(t("tip.accountCreateSuccess")).then(() =>
        //   emits("accountSubmitted", createdAccount)
        // );
      } catch (e: any) {
        console.log(e);
        ElNotification.error({
          title: "Error",
          message: e?.response?.data?.message
            ? e.response.data.message
            : "Error Submit",
          type: "error",
        });
        // MsgPrompt.error(error);
      } finally {
        isSaving.value = false;
      }
    } else {
      ElNotification.error({
        title: "Error",
        message: "error submit!" + fields,
        type: "error",
      });
      // MsgPrompt.error("error submit!" + fields);
    }
  });
};

const resetForm = () => {
  formData.value.platform = 0;
  formData.value.serviceId = 0;
  formData.value.group = "";
  formData.value.pcTag = "None";
};

const getAccountAndApplicationInfo = async () => {
  isLoading.value = true;
  formData.value = {
    pcTag: "None",
    password: "Pass!1234", // only for development
    accountId:
      accountDetails.value?.id ?? applicationDetails.value?.referenceId,
    ...applicationDetails.value.supplement,
    currencyId:
      applicationDetails.value.supplement.currencyId === -1
        ? null
        : applicationDetails.value.supplement.currencyId,
  };

  originalFormData.value = { ...formData.value };
  formData.value.serviceId = originalFormData.value.serviceId;

  // try {
  //   const getClientRebateRule = await RebateService.getRebateClientRule({
  //     clientAccountId: accountDetails.value.id,
  //   });
  //   console.log("getClientRebateRule", getClientRebateRule);

  //   pipCommissionDecision.value = getClientRebateRule.data[0].schema.find(
  //     (obj) =>
  //       obj.accountType === applicationDetails.value.supplement.accountType
  //   );

  //   if (pipCommissionDecision.value == undefined) {
  //     pipCommissionDecision.value = {
  //       commission: 0,
  //       pips: 0,
  //     };
  //   }
  // } catch (e) {
  //   try {
  //     const referralCodeInfo = await GlobalService.getReferralCodeSupplement(
  //       pendingApplication.value.supplement.referCode
  //     );
  //     pipCommissionDecision.value =
  //       referralCodeInfo.summary.allowAccountTypes.find(
  //         (obj) =>
  //           obj.accountType === applicationDetails.value.supplement.accountType
  //       );
  //     console.log("referralCodeInfo", referralCodeInfo);
  //   } catch (e) {
  //     console.log("e", e);
  //     pipCommissionDecision.value = {
  //       commission: 0,
  //       pips: 0,
  //     };
  //   }
  //   // MsgPrompt.error("Error getting rebate rule");
  // }

  const referralCode =
    props.accountDetails?.referCode ??
    pendingApplication.value.supplement.referCode;

  try {
    const referralCodeInfo = await GlobalService.getReferralCodeSupplement(
      referralCode
    );

    const allowAccountTypes =
      referralCodeInfo.summary?.allowAccountTypes ??
      referralCodeInfo.summary?.Schema ??
      referralCodeInfo.summary?.schema;

    pipCommissionDecision.value = allowAccountTypes.find(
      (obj) =>
        obj.accountType === applicationDetails.value.supplement.accountType
    );

    if (pipCommissionDecision.value == undefined) {
      console.log(
        "application account type",
        applicationDetails.value.supplement.accountType
      );
      console.log("referralCode AllowAccountTypes", allowAccountTypes);
      pipCommissionDecision.value = {
        commission: 0,
        pips: 0,
      };
    }
  } catch (e) {
    console.log(e);
    pipCommissionDecision.value = {
      commission: 0,
      pips: 0,
    };
  }

  isLoading.value = false;
};

const updateTag = async (_id: any) => {
  if (formData.value.pcTag == "None") {
    return;
  }

  const finalData = {
    id: _id,
    tagNames: [formData.value.pcTag],
  };

  await AccountService.updateAccountTagsById(
    accountDetails.value.id,
    finalData
  );
};

onMounted(async () => {
  await getAccountAndApplicationInfo();
});

__expose({
  resetForm,
  show: getAccountAndApplicationInfo,
  close,
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_form, {
                "label-width": "100px",
                ref_key: "elFormRef",
                ref: elFormRef,
                model: formData.value,
                rules: rules
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('fields.platform'),
                    prop: "platform"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.platform,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.platform) = $event)),
                        disabled: 
                  _unref(applicationDetails).status !== _unref(ApplicationStatusType).Approved
                ,
                        name: "platform",
                        type: "text",
                        placeholder: _ctx.$t('action.select')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigAllPlatformSelections), ({ label, platform }, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: label,
                              key: index,
                              value: platform
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  (typeof formData.value.platform === 'number')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: _ctx.$t('fields.server'),
                        prop: "serviceId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: formData.value.serviceId,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.serviceId) = $event)),
                            disabled: 
                  _unref(applicationDetails).status !== _unref(ApplicationStatusType).Approved
                ,
                            name: "serviceId",
                            type: "text",
                            placeholder: _ctx.$t('action.select')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(serverSelections.value, ({ label, value }, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: index,
                                  label: label,
                                  value: value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (typeof formData.value.serviceId === 'number')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: _ctx.$t('fields.group'),
                        prop: "group"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: formData.value.group,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.group) = $event)),
                            filterable: "",
                            disabled: 
                  _unref(applicationDetails).status !== _unref(ApplicationStatusType).Approved
                ,
                            name: "group",
                            type: "text",
                            placeholder: _ctx.$t('action.select')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupSelections.value, (_group, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: index,
                                  value: _group
                                }, null, 8, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('fields.currency'),
                    prop: "currencyId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.currencyId,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.currencyId) = $event)),
                        disabled: 
                  _unref(applicationDetails).status !== _unref(ApplicationStatusType).Approved
                ,
                        name: "currencyId",
                        type: "text",
                        placeholder: _ctx.$t('action.select')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigBackendCurrencySelections), ({ value, label }, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: index,
                              label: label,
                              value: value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('fields.leverage'),
                    prop: "leverage"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_el_input, {
                          disabled: 
                    _unref(applicationDetails).status !== _unref(ApplicationStatusType).Approved
                  ,
                          modelValue: formData.value.leverage,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.leverage) = $event)),
                          name: "leverage",
                          style: {"width":"50px"}
                        }, null, 8, ["disabled", "modelValue"]),
                        _hoisted_5
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('fields.accountTag'),
                    prop: "pcTag"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: formData.value.pcTag,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.pcTag) = $event)),
                        size: "large"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_button, {
                            label: "AddPips",
                            value: "AddPips"
                          }),
                          _createVNode(_component_el_radio_button, {
                            label: "AddCommission",
                            value: "AddCommission"
                          }),
                          _createVNode(_component_el_radio_button, {
                            label: "None",
                            value: "None"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("tip.accountPcTag")), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: submit,
                        loading: isSaving.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("action.submit")), 1)
                        ]),
                        _: 1
                      }, 8, ["loading"]),
                      _createVNode(_component_el_button, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("action.review")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_form, { "label-width": "150px" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('fields.platform'),
                    prop: "platform"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_el_input, {
                          value: 
                    originalFormData.value.platform
                      ? _ctx.$t('type.platform.' + originalFormData.value.platform)
                      : 'None'
                  ,
                          name: "platform",
                          style: {"width":"100%"},
                          disabled: ""
                        }, null, 8, ["value"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('fields.server'),
                    prop: "server"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_el_input, {
                          value: 
                    _unref(services).find(
                      (item) => item.id === originalFormData.value.serviceId
                    )?.name +
                      ' ( ' +
                      _unref(services).find(
                        (item) => item.id === originalFormData.value.serviceId
                      )?.description +
                      ' )' ?? 'None'
                  ,
                          name: "server",
                          style: {"width":"100%"},
                          disabled: ""
                        }, null, 8, ["value"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('fields.currency'),
                    prop: "currency"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_el_input, {
                          value: 
                    _unref(ConfigBackendCurrencySelections).find(
                      (item) => item.value === originalFormData.value.currencyId
                    )?.label ?? 'None'
                  ,
                          name: "currency",
                          style: {"width":"100%"},
                          disabled: ""
                        }, null, 8, ["value"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('fields.leverage'),
                    prop: "leverage"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_el_input, {
                          value: formData.value.leverage + ' : 1',
                          name: "leverage",
                          style: {"width":"100%"},
                          disabled: ""
                        }, null, 8, ["value"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('fields.accountType'),
                    prop: "accountType"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_el_input, {
                          value: 
                    _ctx.$t(
                      'type.account.' +
                        _unref(applicationDetails).supplement.accountType
                    )
                  ,
                          name: "accountType",
                          style: {"width":"100%"},
                          disabled: ""
                        }, null, 8, ["value"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: 'Rate Option',
                    prop: "rateOption"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_el_input, {
                          value: pipCommissionDecision.value.optionName,
                          name: "rateOption",
                          style: {"width":"100%"},
                          disabled: ""
                        }, null, 8, ["value"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('fields.pipCommission'),
                    prop: "pipCommission"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_el_input, {
                          value: 
                    pipCommissionDecision.value.commission == 0
                      ? pipCommissionDecision.value.pips == 0
                        ? 'None'
                        : 'Pips'
                      : 'Commission'
                  ,
                          name: "pipCommission",
                          style: {"width":"100%"},
                          disabled: ""
                        }, null, 8, ["value"]),
                        _hoisted_15,
                        _createVNode(_component_el_input, {
                          value: 
                    pipCommissionDecision.value.commission == 0
                      ? pipCommissionDecision.value.pips == 0
                        ? 'None'
                        : pipCommissionDecision.value.pips
                      : pipCommissionDecision.value.commission
                  ,
                          name: "value",
                          style: {"width":"100%"},
                          disabled: ""
                        }, null, 8, ["value"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})